import request from "@/utils/request";
export function saveFeedBack(entity) {
    return request({
      url: "/community_feedback/save",
      method: "post",
      data: entity,
    });
  }
